(function () {
  const content = document.querySelector('.article-template-content');
  const mount = document.getElementById('article-toc');
  if (!content || !mount) return;

  const headings = Array.from(content.querySelectorAll('h2, h3'));
  if (headings.length < 3) {
    mount.remove();
    return;
  }

  const slugify = (s) =>
    s.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);

  const used = new Set();
  const list = document.createElement('ol');
  list.className = 'article-toc-list';

  headings.forEach((h) => {
    if (!h.id) {
      let base = slugify(h.textContent) || 'section';
      let id = base;
      let n = 2;
      while (used.has(id) || document.getElementById(id)) {
        id = `${base}-${n++}`;
      }
      h.id = id;
      used.add(id);
    }
    const li = document.createElement('li');
    li.className = 'article-toc-item article-toc-' + h.tagName.toLowerCase();
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  const heading = document.createElement('div');
  heading.className = 'article-toc-heading';
  heading.textContent = 'In this article';
  mount.appendChild(heading);
  mount.appendChild(list);
  mount.classList.add('is-active');

  // Active-link highlighting via IntersectionObserver
  const links = new Map();
  list.querySelectorAll('a').forEach((a) => links.set(a.getAttribute('href').slice(1), a));

  let activeId = null;
  const setActive = (id) => {
    if (id === activeId) return;
    if (activeId && links.get(activeId)) links.get(activeId).classList.remove('is-active');
    activeId = id;
    if (id && links.get(id)) links.get(id).classList.add('is-active');
  };

  const io = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
      if (visible[0]) setActive(visible[0].target.id);
    },
    { rootMargin: '-20% 0% -65% 0%', threshold: 0 }
  );
  headings.forEach((h) => io.observe(h));
})();
